import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 3,
  class: "acoes-item"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 4,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1)
const _hoisted_13 = { class: "acoes-item" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  class: "ant-row",
  style: {"margin":"10px 0px"}
}
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!
  const _component_baixa_titulos_lancamento_carteira_titulos_modal = _resolveComponent("baixa-titulos-lancamento-carteira-titulos-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, {
      titulo: "TÍTULOS QUE SERÃO CRIADOS",
      class: "ss-alinhar-texto-esquerda"
    }, {
      AcoesExtra: _withCtx(() => [
        _createElementVNode("a", {
          class: "ss-fonte-negrito ss-card-botao-acao-extra",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.abrirAdicaoTitulos()))
        }, "ADICIONAR TÍTULO")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_a_table, {
              columns: _ctx.gradeBase.colunas.filter(item => item.visible),
              "data-source": _ctx.state.computedTitulosLancados,
              key: 'NOVOTITULOS' + _ctx.state.chaveTitulos,
              pagination: false,
              loading: _ctx.telaBase.carregando,
              scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth), y: 500 },
              size: "small"
            }, {
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.key === 'TipoDocumentoFinanceiro')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      title: record.descricaoTipoDocumentoFinanceiro
                    }, _toDisplayString(record.descricaoTipoDocumentoFinanceiro), 9, _hoisted_1))
                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text,2)), 1))
                      : (column.key === 'Acoes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.editarTitulo(record)),
                              title: "Editar"
                            }, [
                              _createVNode(_component_icone, { nome: "editar" })
                            ], 8, _hoisted_5),
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.excluirTitulo(record)),
                              title: "Excluir"
                            }, [
                              _createVNode(_component_icone, { nome: "excluir" })
                            ], 8, _hoisted_6)
                          ]))
                        : (column.key === 'Titulo')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("span", null, [
                                _hoisted_8,
                                _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                              ]),
                              _createElementVNode("span", null, [
                                _hoisted_9,
                                _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                              ]),
                              _createElementVNode("span", null, [
                                _hoisted_10,
                                _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                              ]),
                              _createElementVNode("span", null, [
                                _hoisted_11,
                                _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal,2)), 1)
                              ]),
                              _createElementVNode("span", null, [
                                _hoisted_12,
                                _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.editarTitulo(record)),
                                    title: "Editar"
                                  }, [
                                    _createVNode(_component_icone, { nome: "editar" })
                                  ], 8, _hoisted_14),
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.excluirTitulo(record)),
                                    title: "Excluir"
                                  }, [
                                    _createVNode(_component_icone, { nome: "excluir" })
                                  ], 8, _hoisted_15)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
              ]),
              emptyText: _withCtx(() => [
                (_ctx.state.quantidadeTitulos <= 0)
                  ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                      key: 0,
                      mensagem: "Nenhum título adicionado ainda"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source", "loading", "scroll"])),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_totalizador, {
                  titulo: "QTDE TÍTULOS",
                  monetario: false,
                  valor: _ctx.state.quantidadeTitulos,
                  casasDecimais: 0
                }, null, 8, ["valor"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_totalizador, {
                  titulo: "TOTAL TÍTULOS",
                  monetario: true,
                  valor: _ctx.state.totalTitulosLancados
                }, null, 8, ["valor"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_totalizador, {
                  titulo: "TOTAL BAIXA TÍTULOS",
                  monetario: true,
                  valor: _ctx.props.totalBaixa
                }, null, 8, ["valor"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_a_tooltip, {
                  placement: "top",
                  title: '(Total Créditos Utilizados + Total Novos Títulos + Total ' + _ctx.obterDescricaoTipoTitulos() + ') - Total Baixa Títulos'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_totalizador, {
                      titulo: "VALOR RESTANTE",
                      monetario: true,
                      valor: _ctx.props.valorRestante
                    }, null, 8, ["valor"])
                  ]),
                  _: 1
                }, 8, ["title"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_baixa_titulos_lancamento_carteira_titulos_modal, {
      visivel: _ctx.state.exibirAdicionarTitulo,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirAdicionarTitulo) = $event)),
      empresa: _ctx.props.empresa,
      tipoTituloFinanceiro: _ctx.props.tipoTituloFinanceiro,
      contaPadrao: _ctx.props.contaPadrao,
      tituloFinanceiro: _ctx.state.tituloSelecionado,
      onConfirmacao: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adicionarTitulos($event)))
    }, null, 8, ["visivel", "empresa", "tipoTituloFinanceiro", "contaPadrao", "tituloFinanceiro"])
  ]))
}